import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import Button from 'components/util/Button'
import Modal from 'components/util/Modal'
import Loader from 'components/util/Loader'
import styles from './_confirmModal.css'

export default function ConfirmModal (props) {
  const {
    isOpen,
    isLoading,
    titleComponent,
    confirmAction,
    cancelAction,
  } = props

  return (
    <Modal isOpen={isOpen}>
      <div className={styles.modalContainer}>
        <h3 className={styles.modalHeader}>
          {titleComponent}
        </h3>
        {!isLoading ?
          <div className={styles.modalBody}>
            <Button
              size='small'
              type='action'
              el='button'
              onClick={() => confirmAction()}
              className={styles.confirmButton}>
              <FormattedMessage
                id='confirmmodal.confirm'
                defaultMessage='OK'
              />
            </Button>
            <Button
              size='small'
              type='secondary'
              el='button'
              onClick={() => cancelAction()}>
              <FormattedMessage
                id='confirmmodal.cancel'
                defaultMessage='Cancel'
              />
            </Button>
          </div>
          :
            <div className={styles.loader}>
              <Loader type='spin' height={30} width={30} />
            </div>}
      </div>
    </Modal>
  )
}

ConfirmModal.propTypes = {
  isOpen: PropTypes.bool,
  isLoading: PropTypes.bool,
  titleComponent: PropTypes.node,
  confirmAction: PropTypes.func,
  cancelAction: PropTypes.func,
}
